define("preview-grid/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "preview-grid/config/environment", "preview-grid/resolver"], function (_exports, _engine, _emberLoadInitializers, _environment, _resolver) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/engine",0,"ember-load-initializers",0,"preview-grid/config/environment",0,"preview-grid/resolver"eaimeta@70e063a35619d71f
  const {
    modulePrefix
  } = _environment.default;
  const Eng = _engine.default.extend({
    modulePrefix,
    Resolver: _resolver.default,
    dependencies: {
      services: ['alerts', 'auth', 'cache', 'credential-status', 'dialog-manager', 'errors', 'events', 'instagram', 'intl', 'locale', 'media-labels', 'media-library', 'media-navigation', 'perfect-scroll', 'router', 'schedule', 'schedule/caption-hashtags', 'schedule/post', 'schedule/posts-pending-approval', 'seamless-checkout-manager', 'secondary-modal', 'segment', 'selected-social-profiles', 'social/facebook-graph', 'social/instagram-auth', 'social/instagram-business', 'store', 'subscriptions', 'user-config', 'user-role'],
      externalRoutes: ['analytics', 'calendar', 'plans', 'schedule', 'social_profiles', 'stories', 'cluster.media.edit', 'cluster.schedule.drafts', 'cluster.schedule.calendar', 'cluster.schedule.stories', 'cluster.schedule.list', 'cluster.schedule.preview-grid']
    }
  });
  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = _exports.default = Eng;
});